import React from 'react';
import { preset as fetchPreset } from '@kne/react-fetch';
import { Empty, message, Spin } from 'antd';
import axios from 'axios';
import { preset as remoteLoaderPreset } from '@kne/remote-loader';
import { enums } from '@components/ResumeForm';

import apis from './apis';

window.PUBLIC_URL = process.env.PUBLIC_URL;
window.ENV_TYPE = window.runtimeEnv?.envType || 1;

const componentsCoreRemote =
  // process.env.NODE_ENV !== 'development' ?
  {
    remote: 'components-core',
    url: 'https://registry.npmmirror.com',
    tpl: '{{url}}/@kne-components%2f{{remote}}/{{version}}/files/build',
    defaultVersion: '0.2.14'
    // } : {
    //   remote: 'components-core',
    //   url: 'http://localhost:3002',
    //   tpl: '{{url}}',
    //   // url: 'https://uc.fatalent.cn',
    //   defaultVersion: '0.1.36'
  };

remoteLoaderPreset({
  remotes: {
    default: componentsCoreRemote,
    'components-core': componentsCoreRemote,
    'components-iconfont': {
      remote: 'components-iconfont',
      url: 'https://registry.npmmirror.com',
      tpl: '{{url}}/@kne-components%2f{{remote}}/{{version}}/files/build',
      defaultVersion: '0.1.3'
    },
    'lhh-resume':
      process.env.NODE_ENV === 'development'
        ? {
            remote: 'lhh-resume',
            url: '/',
            tpl: '{{url}}'
          }
        : {
            remote: 'lhh-resume',
            url: 'https://registry.npmmirror.com',
            tpl: '{{url}}/@kne-components%2f{{remote}}/{{version}}/files/build',
            defaultVersion: process.env.DEFAULT_VERSION
          }
  }
});

export const ajax = axios.create({
  baseURL: window.runtimeApiUrl || '',
  validateStatus: function () {
    return true;
  }
});

ajax.interceptors.response.use(response => {
  if ((response.status === 200 && response.data.code === 401) || (response.data.hasOwnProperty('code') && response.data.code === 90005)) {
    return response;
  }
  if ((response.status !== 200 || (response.data.hasOwnProperty('code') && response.data.code !== 0)) && response.config.showError !== false) {
    message.error(response.data.msg || '请求发生错误');
  }
  return response;
});

fetchPreset({
  ajax,
  loading: <Spin delay={500} style={{ position: 'absolute', left: '50%', padding: '10px', transform: 'translateX(-50%)' }} />,
  error: null,
  empty: <Empty />,
  transformResponse: response => {
    const { data } = response;
    response.data = {
      code: data.code === 0 ? 200 : data.code,
      msg: data.msg,
      results: data.data
    };
    return response;
  }
});

export const globalPreset = {
  ajax,
  apis,
  enums,
  themeToken: {
    colorPrimary: '#4F185A',
    colorPrimaryHover: '#702280'
  }
};
